import {

    FETCH_EVENTS_VEHICLE_PENDING,
    FETCH_EVENTS_VEHICLE_FULFILLED,
    FETCH_EVENTS_VEHICLE_REJECTED,

    DELETE_EVENTS_VEHICLE_PENDING,
    DELETE_EVENTS_VEHICLE_FULFILLED,
    DELETE_EVENTS_VEHICLE_REJECTED,

    CHANGE_EVENTS_VEHICLE

} from './eventsVehiclePeriodActions'

const moment = require('moment');
const initialState = {
    loading: false,
    listOfEventsVehiclePeriod: [],
    eventsVehiclePeriod: {
        matriz: 0,
        motorista: 0,
        dataInicial: moment().utc().format("DD/MM/YYYY"),
        horaInicial: '00:00:00',
        dataFinal: moment().utc().format("DD/MM/YYYY"),
        horaFinal: moment().format("HH:mm:ss")
    },
    error: null,
}

export function eventsVehiclePeriodReducer(state = initialState, action) {
    switch (action.type) {
        case CHANGE_EVENTS_VEHICLE:
            return Object.assign({}, state, {
                eventsVehiclePeriod: {
                    ...state.eventsVehiclePeriod,
                    [action.payload.name]: action.payload.value
                }
            })
        case FETCH_EVENTS_VEHICLE_PENDING:
            return Object.assign({}, state, {
                loading: true,
                listOfEventsVehiclePeriod: initialState.listOfEventsVehiclePeriod,
            })
        case FETCH_EVENTS_VEHICLE_FULFILLED:
            console.log(action.payload)
            return Object.assign({}, state, {
                loading: false,
                listOfEventsVehiclePeriod: action.payload
            })
        case FETCH_EVENTS_VEHICLE_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                listOfEventsVehiclePeriod: initialState.listOfEventsVehiclePeriod,
                error: action.payload
            })

        case DELETE_EVENTS_VEHICLE_PENDING:
            return Object.assign({}, state, {
                loading: true,
            })
        case DELETE_EVENTS_VEHICLE_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
            })
        case DELETE_EVENTS_VEHICLE_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        default:
            return state
    }
}